<script lang="ts">
  import type {
    GlobalProperties,
    UseFormattedProps,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
  export let settings: GlobalProperties;

  $: ({ headingFont } = settings);
  $: vars = `--font-family: ${headingFont?.title || 'DM Sans'}`;
</script>

{#if properties}
  <div
    class="image-section"
    id={properties?.anchor}
    style="{vars}; background-color:{properties.fullWidth === 'active'
      ? ''
      : properties.backgroundColor}"
  >
    <div
      class="image {properties.fullWidth === 'active' ? 'fullWidth' : ''}"
      style="border-radius: {properties.borderRadius}"
    >
      <img
        src={properties.image}
        alt=""
        style="border-radius: {properties.borderRadius};
             aspect-ratio: {properties.fullWidth === 'active'
          ? 'auto'
          : properties.aspectRatio};"
      />
    </div>
  </div>
{/if}

<style>
  .image-section {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .image.fullWidth {
    padding: 0;
    width: 100%;
    height: 100%;
  }
  .image {
    height: 100%;
    padding: 40px 20px;
  }
  img {
    width: 100%;
    object-fit: cover;
    max-height: 600px;
  }
</style>
